import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Application } from 'src/app/shared/models/Application.model';

@Component({
  selector: 'app-detailed-application-form',
  templateUrl: './detailed-application-form.component.html',
  styleUrls: ['./detailed-application-form.component.css']
})
export class DetailedApplicationFormComponent implements OnInit {
  @Input() application: Application;
  @Input() form: FormGroup;

  constructor() {}

  ngOnInit(): void {
    this.form.get('Id').setValue(this.application.Id);
  }
}
